'use client';
import { useState, useEffect } from 'react';
import Popup from './Popup';

export default function ClientPopup({ shema }) {
    const [activePopup, setActivePopup] = useState(null);

    useEffect(() => {
        const handleClick = (e) => {
            const target = e.target.closest('.drug-li-item');
            if (target) {
                const popupId = target.getAttribute('data-popup');
                setActivePopup(popupId);
            }
        };

        const handleOverlayClick = (e) => {
            if (e.target.id === 'overlay') {
                setActivePopup(null);
            }
        };

        document.addEventListener('click', handleClick);
        document.addEventListener('click', handleOverlayClick);

        return () => {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('click', handleOverlayClick);
        };
    }, []);

    const handleClosePopup = () => setActivePopup(null);

    return (
        <>
            <div
                id="overlay"
                style={{
                    display: activePopup ? 'block' : 'none',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.34)', // Совпадает с твоим CSS
                    zIndex: 90, // Совпадает с твоим CSS
                }}
            />
            {activePopup && (
                <Popup
                    popupId={activePopup}
                    preparat={shema.flatMap(s => s.preparat).find(p => `popup${p.nazvanie}` === activePopup)}
                    onClose={handleClosePopup}
                    // Передаем стиль напрямую, чтобы переопределить display: none
                    style={{ display: 'block' }}
                />
            )}
        </>
    );
}